define('components/loader/models/LoaderModel', [

], function() {

    var LoaderModel = Backbone.Model.extend({
        defaults: {
            viewId: "loader-id",        // Classic default viewId
            percentage: 0,              // Percentage of progress
            imageUrl: "",               // Url of image
            progressLabel: "%",         // Label of progress
            propertiesUpdated: []       // Property update on progress ( "height", "width", "opacity" )
        }
    });

    return LoaderModel;
});
